/* =========================================================
   FURNIVERSAL — website content model
   ---------------------------------------------------------
   One file, two jobs:

   1. FV_CONTENT_DEFAULTS — every word, photo and video on the
      site that isn't a product. This mirrors the HTML, so the
      site looks identical before the admin has changed a thing.

   2. FV_CONTENT_SCHEMA — describes those values so the admin
      panel (Website tab) can build its whole editing form
      automatically. Add a field here and it appears in the
      admin, no admin code to touch.

   The admin saves changes to data/content.json; assets/js/content.js
   merges that file over the defaults and applies it to the page.

   Link fields accept:
     shop.html            a page on this site
     index.html#contact   a section on a page
     whatsapp:Your text   opens WhatsApp with that message pre-filled
     https://...          any external link
   ========================================================= */
(function () {
  "use strict";

  /* =======================================================
     1. DEFAULTS — the live site copy
     ======================================================= */
  window.FV_CONTENT_DEFAULTS = {

    /* ---------------- Global: header, footer, contact ---------------- */
    global: {
      logo: "assets/img/logo.png",
      logoLight: "assets/img/logo-light.png",
      nav: [
        { label: "Home",      href: "index.html" },
        { label: "Shop",      href: "shop.html" },
        { label: "Showroom",  href: "showroom.html" },
        { label: "Interiors", href: "interiors.html" },
        { label: "Brands",    href: "brands.html" },
        { label: "Contact",   href: "index.html#contact" }
      ],
      headerCta: {
        label: "Book a Showroom Visit",
        href: "showroom.html#visit"
      },
      whatsapp: {
        number: "919148236891",
        display: "+91 91482 36891",
        greeting: "Hi Furniversal, I would like a free design consultation."
      },
      contact: {
        email: "hello@furniversal.in",
        instagramHandle: "@furniversal.india",
        instagramUrl: "https://www.instagram.com/furniversal.india",
        facebookUrl: "",
        youtubeUrl: "",
        pinterestUrl: "",
        xUrl: "",
        address: "Furniversal Sofa Studio, Banaswadi, Bengaluru, Karnataka",
        mapUrl: "https://www.google.com/maps/search/?api=1&query=Furniversal+Banaswadi+Bengaluru",
        mapEmbed: "https://www.google.com/maps?q=Furniversal+Banaswadi+Bengaluru&output=embed",
        hoursLabel: "Sofa Studio, Banaswadi",
        hoursValue: "Open daily · 10am–7:30pm · walk-ins welcome"
      },
      /* Colour swatches offered on every sofa (product page + shop cards).
         Each product also carries its own "as photographed" colour. */
      swatches: {
        fabric: [
          { name: "Ivory",        hex: "#EDE6D6" },
          { name: "Oat",          hex: "#D9CDB5" },
          { name: "Sand",         hex: "#CDBB9A" },
          { name: "Beige",        hex: "#C9B99B" },
          { name: "Greige",       hex: "#A69B8E" },
          { name: "Olive",        hex: "#6B6B4A" },
          { name: "Forest",       hex: "#2F4A3A" },
          { name: "Teal",         hex: "#2F5D62" },
          { name: "Slate Blue",   hex: "#4F6272" },
          { name: "Mustard",      hex: "#C9A045" },
          { name: "Rust",         hex: "#A85A3A" },
          { name: "Blush",        hex: "#D9B5A5" },
          { name: "Charcoal",     hex: "#3B3B3B" }
        ],
        leather: [
          { name: "Ivory",        hex: "#F0EADB" },
          { name: "Cream",        hex: "#EDE3D0" },
          { name: "Sand",         hex: "#C8B28F" },
          { name: "Camel",        hex: "#B58B5A" },
          { name: "Tan",          hex: "#B0713F" },
          { name: "Caramel",      hex: "#A9683B" },
          { name: "Cognac",       hex: "#8B4A2B" },
          { name: "Chocolate",    hex: "#4A2E22" },
          { name: "Taupe",        hex: "#8C7B6B" },
          { name: "Burnt Orange", hex: "#B4552F" },
          { name: "Forest Green", hex: "#2E4A3A" },
          { name: "Emerald",      hex: "#1F5F4A" },
          { name: "Black",        hex: "#1E1E1E" }
        ]
      },
      widget: {
        logo: "assets/img/whatsapp-icon.png",
        name: "Furniversal",
        status: "Typically replies instantly",
        senderName: "Furniversal Team",
        message: "Hi there! 👋 Ask us about any sofa, custom sizes, fabrics or a showroom visit.",
        ctaLabel: "Chat now"
      },
      footer: {
        blurb: "Custom sofas and complete home interiors, made in our 5,000 sq.ft. studio in Banaswadi, Bengaluru.",
        exploreTitle: "Explore",
        exploreLinks: [
          { label: "Home",      href: "index.html" },
          { label: "Shop",      href: "shop.html" },
          { label: "Showroom",  href: "showroom.html" },
          { label: "Interiors", href: "interiors.html" },
          { label: "Brands",    href: "brands.html" },
          { label: "Customer services", href: "support.html" }
        ],
        categoriesTitle: "Categories",
        categoryLinks: [
          { label: "Sofas",       href: "shop.html?cat=Sofas" },
          { label: "Sofa Sets",   href: "shop.html?cat=Sofa%20Sets" },
          { label: "Sectionals & L-shapes", href: "shop.html?cat=Sectionals" },
          { label: "Recliners",   href: "shop.html?cat=Recliners" },
          { label: "Armchairs",   href: "shop.html?cat=Armchairs" },
          { label: "Beds",        href: "shop.html?cat=Beds" }
        ],
        contactTitle: "Get in Touch",
        notes: "10-year warranty · Free delivery & installation\nApprox. 30-day delivery on custom orders",
        ctaLabel: "Chat With Us",
        ctaHref: "whatsapp:Hi Furniversal, I'd like a free consultation.",
        policyLinks: [
          { label: "Terms & Conditions", href: "support.html#terms" },
          { label: "Privacy Policy",     href: "support.html#privacy" },
          { label: "Refund Policy",      href: "support.html#refund" },
          { label: "Shipping Policy",    href: "support.html#shipping" },
          { label: "Return Policy",      href: "support.html#returns" }
        ],
        copyright: "© 2026 Furniversal. All rights reserved."
      }
    },

    /* ---------------- Home page ---------------- */
    home: {
      seo: {
        title: "Furniversal | Custom Sofas Made Around You, Bengaluru",
        description: "Premium sofas customised to your space, comfort and personality. Fabric or genuine leather, recliners and custom sizes, from ₹1.2 lakh with approx. 30-day delivery and a 10-year warranty. Visit our 5,000 sq.ft. sofa studio in Banaswadi, Bengaluru."
      },
      hero: {
        eyebrow: "Custom sofas · Banaswadi, Bengaluru",
        title: "Your sofa. Your size.\n*Your style.*",
        text: "Premium sofas customised to your space, comfort and personality.",
        pills: "Fabric\nGenuine leather\nRecliners\nCustom sizes",
        cta1: { label: "Explore Sofas", href: "shop.html" },
        cta2: { label: "Book a Showroom Visit", href: "showroom.html#visit" },
        studio: "5,000 sq.ft. Custom Sofa Studio, Banaswadi, Bengaluru",
        studioHref: "showroom.html",
        trust: "50 years of manufacturing experience · Designed by globally renowned designers",
        video: "assets/video/hero.mp4",
        poster: "assets/img/home/hero-video-poster.jpg",
        scrollLabel: "Scroll"
      },
      proof: [
        { num: "₹1.2 lakh",   label: "Sofas starting from" },
        { num: "~30 days",    label: "Delivery on custom orders" },
        { num: "50 years",    label: "Manufacturing experience" },
        { num: "Global",      label: "Renowned designers" },
        { num: "10-year",     label: "Warranty on every sofa" },
        { num: "5,000 sq.ft.", label: "Sofa studio in Banaswadi" }
      ],
      categories: {
        title: "Shop by category",
        linkLabel: "View the full collection",
        linkHref: "shop.html",
        moreLabel: "Also made to order",
        more: "Home theatre recliners\nPuffies & ottomans\nSofa-cum-beds\nDining tables\nCentre & side tables",
        cards: [
          { image: "assets/img/home/cat-sofas.jpg",       kicker: "Stationary",         title: "Sofas",       href: "shop.html?cat=Sofas" },
          { image: "assets/img/products/kendra/01.jpg",   kicker: "3+2 · 3+1+1",         title: "Sofa Sets",   href: "shop.html?cat=Sofa%20Sets" },
          { image: "assets/img/home/cat-sectionals.jpg",  kicker: "L-shapes · corners",  title: "Sectionals",  href: "shop.html?cat=Sectionals" },
          { image: "assets/img/home/cat-recliners.jpg",   kicker: "Manual · power",      title: "Recliners",   href: "shop.html?cat=Recliners" },
          { image: "assets/img/products/peyton/01.jpg",   kicker: "Accent seating",      title: "Armchairs",   href: "shop.html?cat=Armchairs" },
          { image: "assets/img/home/cat-beds.jpg",        kicker: "Storage · hydraulic", title: "Beds",        href: "shop.html?cat=Beds" }
        ]
      },
      featured: {
        eyebrow: "Bestsellers",
        title: "Sofas our clients love",
        text: "Made to order in your size, fabric or leather and colour.",
        slugs: ["kendra", "gemma", "lola", "mystica", "valencia", "fritz", "cloudoo", "quinn"],
        buttonLabel: "View Full Collection",
        buttonHref: "shop.html"
      },
      motion: {
        eyebrow: "Furniture in motion",
        title: "See our pieces come to life",
        text: "Tap any clip to open the piece.",
        linkLabel: "View this piece",
        max: 20,
        speed: 30,
        autoMs: 6000
      },
      custom: {
        eyebrow: "Why Furniversal?",
        title: "Premium sofas, designed around you",
        quote: "Most sofas are made first and fitted later. We do it differently.",
        quoteSub: "Your sofa isn't standard. We make it around you.",
        flow: "Visit the studio → sit on it → customise it → we build it for your home",
        tiles: [
          { icon: "ruler",   title: "Your custom size",     text: "Made around your room, to the centimetre." },
          { icon: "seat",    title: "Your comfort",         text: "Firm, medium or soft. Stationary or recliner." },
          { icon: "fabric",  title: "Your material",        text: "Premium fabric or genuine leather, full or half (body-touch)." },
          { icon: "palette", title: "Your colour",          text: "Pick your finish from real fabric and leather swatches." },
          { icon: "shield",  title: "Built for the long run", text: "10-year warranty on every sofa we make." },
          { icon: "clock",   title: "Made faster",          text: "Approx. 30-day delivery, subject to fabric or leather availability." }
        ]
      },
      estimate: {
        eyebrow: "Design your sofa",
        title: "Get your sofa recommendation",
        text: "Five quick questions. A designer replies on WhatsApp with a recommendation and an estimate.",
        bullets: "A personal recommendation within a day\nNo obligation, no visit needed\nEstimates from ₹1.2 lakh",
        formTitle: "Get your sofa estimate",
        formNote: "Takes 30 seconds. We reply on WhatsApp.",
        typeLabel: "What are you looking for?",
        types: "3 Seater\n3+2\n3+1+1\nL-shape (LHS)\nL-shape (RHS)\nRecliner\nHome theatre\nSectional\nSofa-cum-bed\nOther",
        materialLabel: "Material",
        materials: "Fabric\nGenuine leather\nNot sure",
        colourLabel: "Colour preference",
        colourPlaceholder: "e.g. olive green, cognac, ivory…",
        roomLabel: "Approximate room size",
        roomPlaceholder: "e.g. 14 × 16 ft, or the wall length",
        photoNote: "I have a photo of the room and will attach it in the WhatsApp chat.",
        photoLine: "I'll attach it in this chat",
        budgetLabel: "Approximate budget",
        budgets: "₹1.3–1.75L\n₹1.75–2.5L\n₹2.5–3.5L\n₹3.5L+",
        nameLabel: "Name",
        phoneLabel: "WhatsApp number",
        submitLabel: "Get my estimate",
        visitLabel: "Book a showroom consultation",
        disclaimer: "Your details only open a pre-filled WhatsApp chat. No spam."
      },
      compare: {
        eyebrow: "Why custom?",
        title: "Your living room isn't standard. Why should your sofa be?",
        standardTitle: "A standard sofa",
        standardItems: "Fixed dimensions\nLimited colours\nLimited materials\nYou compromise",
        customTitle: "A Furniversal sofa",
        customItems: "Custom dimensions, made around your room\nCustom configuration: 3+2, L-shape, sectional, recliner\nPremium fabric or genuine leather\nYour colour, chosen from real swatches\nYour comfort: soft, medium or firm\n10-year warranty and free installation"
      },
      showroom: {
        eyebrow: "Visit the studio",
        title: "See it. Feel it. Customise it.",
        text: "Sit on 32+ sofas, compare fabrics and genuine leathers, test comfort and pick your colour with a designer beside you.",
        image: "assets/img/home/feature-living.jpg",
        badgeNum: "32+",
        badgeText: "Sofas on display",
        list: "32+ sofa displays\nFabric collections\nGenuine leather\nRecliners\nComfort testing\nColour selection",
        cta1: { label: "Book a Showroom Visit", href: "showroom.html#visit" },
        cta2: { label: "Get Directions", href: "https://www.google.com/maps/search/?api=1&query=Furniversal+Banaswadi+Bengaluru" }
      },
      reviews: {
        eyebrow: "Loved by homeowners",
        title: "What our clients say",
        text: "Real Google reviews from Furniversal homes.",
        more: "Read more",
        less: "Show less",
        items: [
          { name: "Vinay Kumar",  time: "2 weeks ago", text: "Choosing Furniversal Fine Furniture from across the globe was the best decision for our home. Their team was professional, highly responsive, and adhered to our strict timeline. The quality of the carpentry and custom fixtures exceeded our expectations. I highly recommend them for any interior project! So grateful for you. Always. Thank you Mohammed Mujabir for making my day brighter, I truly appreciate all that you do." },
          { name: "Santhosh S K", time: "a month ago", text: "Amazing collection of premium luxury furniture. The customization options are top-notch and the quality is excellent. Highly recommended in Bengaluru." },
          { name: "Mumtaz Salim", time: "2 weeks ago", text: "Amazing collection 😍😍" }
        ]
      },
      split: {
        eyebrow: "Beyond the sofa",
        title: "From a single sofa to your whole home",
        text: "One brand for furniture and complete home interiors, from a single statement piece to a full-home fit-out.",
        bullets: "Free in-home or virtual design consultation\n3D design & transparent quotation\nHand-selected materials & fabrics\nInstallation, styling and handover",
        buttonLabel: "Explore Interiors",
        buttonHref: "interiors.html",
        image: "assets/img/home/feature-bedroom.jpg",
        badgeNum: "500+",
        badgeText: "Homes furnished & designed"
      },
      faq: {
        eyebrow: "Good to know",
        title: "Frequently asked questions",
        items: [
          { q: "How much does a Furniversal sofa cost?",                 a: "Sofas start from around ₹1.2 lakh. The final price depends on the configuration (3-seater, 3+2, L-shape, recliner), the fabric or leather you choose and any custom sizing. Every product page shows a starting price, and you can get an estimate in 30 seconds with the \"Get your sofa estimate\" form. No Cost EMI is available." },
          { q: "Can I get a sofa made to my room's size?",                 a: "Yes, that's what we do. Share your wall length or room size and we build the sofa around it: width, depth, seat height, configuration and even the side your chaise sits on." },
          { q: "How long does delivery take?",                              a: "Custom orders take approximately 30 days from confirmation, subject to the availability of your chosen colour and fabric or leather. Delivery and installation in Bengaluru are free." },
          { q: "What does the 10-year warranty cover?",                     a: "The frame, seating structure and mechanisms (including recliner motors) are covered for 10 years against manufacturing defects. Normal wear of fabric and leather, misuse and accidental damage aren't covered. See our Customer Services page for the full terms and how a claim works." },
          { q: "What is your return policy?",                               a: "A no-questions-asked 7-day return on standard-configuration pieces. Sofas made to a custom size or configuration are built specifically for you, so they can't be returned, but they're covered by the same 10-year warranty." },
          { q: "Fabric or genuine leather, which should I choose?",         a: "Genuine leather is available as full leather or half (body-touch) leather, and ages beautifully. Premium fabrics give you the widest colour choice. The best way to decide is to sit on both at the studio, our designers will help you compare." },
          { q: "Do you also do interiors?",                                 a: "Yes. Furniversal is one brand for furniture and complete home interiors, from a single sofa to a full-home fit-out. See the Interiors page or book a free design consultation." },
          { q: "Where is the showroom?",                                    a: "Our 5,000 sq.ft. Sofa Studio is in Banaswadi, Bengaluru, open daily. Walk in, or book a visit so a designer is ready for you." }
        ]
      },
      contact: {
        eyebrow: "Get in touch",
        title: "Let's design your sofa",
        text: "Tell us about your space. We reply on WhatsApp with options and an estimate. No obligations.",
        formTitle: "Connect with us",
        formNote: "Send it on WhatsApp, or straight to our inbox. We reply within a working day.",
        interests: "A custom sofa\nSofa Sets\nSectionals & L-shapes\nRecliners & home theatre\nArmchairs\nPuffies & ottomans\nBeds & sofa-cum-beds\nDining, centre & side tables\nComplete home interiors\nNot sure yet, need advice",
        submitLabel: "Send via WhatsApp",
        sendLabel: "Send enquiry",
        sending: "Sending…",
        sentMsg: "Thank you! We've received your enquiry and will get back to you within a working day.",
        sendError: "We couldn't send that just now. Please try WhatsApp, or email us directly.",
        sendFallback: "Opening your email app with the details filled in. If nothing happens, use WhatsApp instead.",
        needName: "Please add your name.",
        disclaimer: "No spam. WhatsApp opens a pre-filled chat; Send enquiry emails your details to our team."
      },
      cta: {
        image: "assets/img/home/cta.jpg",
        eyebrow: "Your sofa is one visit away",
        title: "Come and sit on it at the Banaswadi studio",
        text: "Book a visit, or message us on WhatsApp for options and an estimate.",
        cta1: { label: "Book a Showroom Visit", href: "showroom.html#visit" },
        cta2: { label: "Browse Sofas", href: "shop.html" }
      }
    },

    /* ---------------- Shop page ---------------- */
    shop: {
      seo: {
        title: "Shop Custom Sofas, Recliners & Beds | Furniversal Bengaluru",
        description: "Browse Furniversal's collection of premium sofas, sofa sets, sectionals, recliners, armchairs and beds. Made-to-order in genuine leather and premium fabric, custom sizes, starting prices shown, 10-year warranty."
      },
      hero: {
        eyebrow: "The collection",
        title: "Custom sofas & furniture",
        text: "Every piece is a starting point: your configuration, size, fabric or leather and colour."
      },
      help: "Starting prices shown, custom sizes on request\nNo Cost EMI available\nApprox. 30-day delivery · 10-year warranty",
      filters: { allMaterials: "All materials", fabric: "Fabric", leather: "Genuine leather", empty: "No pieces match that filter yet. Message us on WhatsApp and we'll make one for you." },
      card: { fromLabel: "From", moreColours: "colours" },
      cta: {
        eyebrow: "Can't decide?",
        title: "Let our designers help you choose",
        text: "Message us on WhatsApp, or visit the studio and sit on every option.",
        buttonLabel: "Chat With a Designer",
        buttonHref: "whatsapp:Hi Furniversal, I need help choosing a sofa for my home."
      }
    },

    /* ---------------- Product page ---------------- */
    product: {
      detail: {
        namePrefix: "Furniversal",
        titleSuffix: "Custom sofas & furniture, Bengaluru",
        fromLabel: "Starting from",
        priceTag: "Price on enquiry",
        priceSub: "Made-to-order · custom sizing",
        perks: "No Cost EMI available\n7-day no-questions-asked return\nFree delivery & installation",
        sizeLabel: "Size",
        sizeCustom: "Made to your size",
        sizeNote: "Custom sizes made to fit your room, share your wall measurement on WhatsApp.",
        configLabel: "Configuration",
        configCustom: "+ Custom configuration",
        dataSheet: "Request the customisation data sheet",
        materialLabel: "Material",
        matLeatherFull: "Genuine leather · full leather",
        matLeatherHalf: "Genuine leather · half (body-touch)",
        matFabric: "Premium fabric (bouclé, velvet, chenille, linen)",
        colourLabel: "Colour",
        colourOwn: "As photographed",
        colourFabric: "Premium fabric colours",
        colourLeather: "Genuine leather colours",
        comfortLabel: "Comfort",
        deliveryLabel: "Delivery",
        deliveryValue: "From 30 days",
        deliveryNote: "Subject to fabric / leather availability",
        warrantyLabel: "Warranty",
        warrantyValue: "10 years",
        warrantyNote: "What's covered",
        featuresLabel: "Key features",
        trust1: "Free delivery & free installation",
        trust2: "50 years of manufacturing experience",
        trust3: "Designed by internationally renowned designers",
        trust4: "Exceptional customer service & support",
        enquireLabel: "WhatsApp this sofa",
        consultLabel: "Book a showroom consultation",
        estimateLabel: "Get your sofa estimate",
        helpTitle: "Need help? Ask a question",
        helpText: "A designer replies on WhatsApp within minutes.",
        helpCta: "Chat now",
        stickyWa: "WhatsApp",
        stickyEstimate: "Get estimate",
        videoEyebrow: "See it in motion",
        videoTitle: "In real light and detail",
        guideCare: "Maintenance guide",
        guideCareLink: "Read the full care guide",
        guideWarranty: "10-year warranty",
        guideWarrantyLink: "Full warranty details",
        guideShipping: "Shipping & returns",
        guideShippingLink: "Read the full policies"
      },
      customise: {
        eyebrow: "Customise this sofa",
        title: "Design a sofa that fits your life.",
        text: "Six decisions with a designer beside you. Then we build it.",
        steps: [
          { num: "1", title: "Configuration", text: "3+2, L-shape, sectional or recliner." },
          { num: "2", title: "Dimensions",    text: "Made to fit your space, to the centimetre." },
          { num: "3", title: "Material",      text: "Premium fabric or genuine leather." },
          { num: "4", title: "Colour",        text: "Chosen from real swatches, not a screen." },
          { num: "5", title: "Comfort",       text: "Soft, medium or firm, where applicable." },
          { num: "6", title: "We build it",   text: "Approx. 30-day delivery, subject to material availability." }
        ],
        ctaLabel: "Book your custom sofa consultation",
        ctaHref: "whatsapp:Hi Furniversal, I'd like to book a custom sofa consultation."
      },
      family:  { eyebrow: "Same family", title: "More from the", suffix: "family",
                 shapesEyebrow: "Shapes & sizes", shapesTitle: "in other shapes and sizes", shapesCta: "Enquire on WhatsApp" },
      related: { eyebrow: "Recommended for you", title: "You may also like" },
      recent:  { eyebrow: "Recently viewed", title: "Pieces you looked at" },
      cta: {
        image: "assets/img/home/banner.jpg",
        eyebrow: "See it in person",
        title: "Sit on it before you decide",
        text: "Every sofa here is on display at our Banaswadi studio. Come and try it.",
        cta1: { label: "Book a Showroom Visit", href: "showroom.html#visit" },
        cta2: { label: "Back to Shop", href: "shop.html" }
      }
    },

    /* ---------------- Showroom page ---------------- */
    showroom: {
      seo: {
        title: "Sofa Showroom in Banaswadi, Bengaluru | Furniversal Sofa Studio",
        description: "Visit the 5,000 sq.ft. Furniversal Sofa Studio in Banaswadi, Bengaluru: 32+ sofa displays, fabric and genuine leather collections, recliners, comfort testing and customisation consultations. Book a showroom visit."
      },
      hero: {
        eyebrow: "Furniversal Sofa Studio · Banaswadi, Bengaluru",
        title: "See it. *Feel it.* Customise it.",
        text: "5,000 sq.ft. of sofas to sit on, fabrics and leathers to compare, and a designer to customise with.",
        image: "assets/img/home/feature-living.jpg",
        facts: [
          { num: "5,000", label: "sq.ft. studio" },
          { num: "32+",   label: "sofas on display" },
          { num: "7 days", label: "open every week" }
        ],
        cta1: { label: "Book a Showroom Visit", href: "#visit" },
        cta2: { label: "Get Directions", href: "https://www.google.com/maps/search/?api=1&query=Furniversal+Banaswadi+Bengaluru" }
      },
      experience: {
        eyebrow: "What you'll experience",
        title: "Everything you need to decide, in one visit",
        text: "Every option side by side. No pressure, no obligation.",
        cards: [
          { icon: "sofa",    title: "32+ sofa displays",        text: "Sofas, sets, L-shapes, sectionals and recliners, ready to sit on." },
          { icon: "fabric",  title: "Fabric collections",       text: "Every colour, seen in real light." },
          { icon: "hand",    title: "Genuine leather",          text: "Full and half (body-touch) leather to touch and compare." },
          { icon: "seat",    title: "Recliners",                text: "Manual and power, with child-lock, USB and double motors." },
          { icon: "ruler",   title: "Customisation consultation", text: "Bring a wall measurement or floor plan; we design around it." },
          { icon: "check",   title: "Comfort testing",          text: "Soft, medium and firm, tested side by side." },
          { icon: "palette", title: "Colour selection",         text: "Real fabric and leather swatches, matched to your room." },
          { icon: "person",  title: "A designer beside you",    text: "Free advice on size, configuration and material." }
        ]
      },
      visit: {
        eyebrow: "Book a visit",
        title: "Book a showroom visit",
        text: "Walk-ins welcome. Book ahead and a designer will be ready for you.",
        formTitle: "Reserve your slot",
        formNote: "We'll confirm on WhatsApp.",
        interests: "A custom sofa\nSofa Sets\nSectionals & L-shapes\nRecliners & home theatre\nArmchairs\nPuffies & ottomans\nBeds & sofa-cum-beds\nDining, centre & side tables\nComplete home interiors\nJust browsing",
        submitLabel: "Book Showroom Visit",
        disclaimer: "Your details only open a pre-filled WhatsApp chat. No spam."
      },
      reviews: {
        eyebrow: "Google reviews",
        title: "What visitors say"
      },
      stories: {
        eyebrow: "Happy homes",
        title: "Sofas that went home from the studio",
        cards: [
          { image: "assets/img/products/kendra/02.jpg",   quote: "The sofa was customised exactly to our living room. Not a centimetre wasted.", name: "A Furniversal home, Bengaluru" },
          { image: "assets/img/products/gemma/02.jpg",    quote: "Excellent fabric selection. We saw every colour in real light before deciding.", name: "A Furniversal home, Bengaluru" },
          { image: "assets/img/products/lola/02.jpg",     quote: "Very comfortable. We tried soft, medium and firm and picked what suited us.", name: "A Furniversal home, Bengaluru" },
          { image: "assets/img/products/valencia/02.jpg", quote: "Delivery and installation were on time and spotless.", name: "A Furniversal home, Bengaluru" }
        ]
      },
      tour: {
        eyebrow: "Virtual tour",
        title: "Walk through the studio",
        text: "A quick look around before you visit.",
        video: "assets/video/hero.mp4",
        poster: "assets/img/home/hero-video-poster.jpg"
      },
      cta: {
        image: "assets/img/home/cta.jpg",
        eyebrow: "Visit us",
        title: "Your sofa is one visit away",
        text: "Open daily in Banaswadi, Bengaluru. Come and sit on it.",
        cta1: { label: "Book a Showroom Visit", href: "#visit" },
        cta2: { label: "Browse Sofas", href: "shop.html" }
      }
    },

    /* ---------------- Customer services page ---------------- */
    support: {
      seo: {
        title: "Customer Services, Warranty & Policies | Furniversal",
        description: "Need help? Connect with Furniversal on WhatsApp, phone or email, no obligations. 10-year warranty details, delivery and installation, returns, and our terms, privacy, refund and shipping policies."
      },
      hero: {
        eyebrow: "Customer services",
        title: "Need help? Connect with us.",
        text: "No obligations. Ask anything and a real person replies."
      },
      cards: [
        { icon: "chat",  title: "WhatsApp us",        text: "The fastest way to reach a designer. Send a room photo, a measurement or a question.", btnLabel: "Chat on WhatsApp", btnHref: "whatsapp:Hi Furniversal, I need some help." },
        { icon: "mail",  title: "Call or email",      text: "Message us your number and a good time, or email us. We reply within a working day.", btnLabel: "Email us", btnHref: "mailto:hello@furniversal.in" },
        { icon: "map",   title: "Visit the studio",   text: "Open daily in Banaswadi, Bengaluru. Walk in, or book a visit.", btnLabel: "Book a visit", btnHref: "showroom.html#visit" }
      ],
      warranty: {
        eyebrow: "10-year warranty",
        title: "Every Furniversal sofa is covered for 10 years",
        text: "Here's exactly what that means.",
        cards: [
          { title: "What is covered", items: "Solid-wood and engineered frames against structural failure\nSeating suspension and springs\nRecliner mechanisms and motors (manual and power)\nFoam that loses more than 20% of its height\nStitching and upholstery workmanship defects" },
          { title: "What isn't covered", items: "Normal wear, softening and creasing of fabric or leather\nFading from direct sunlight, spills, stains, pet or accidental damage\nDamage from moving, improper cleaning or use beyond household purposes\nNatural leather marks and colour variation between batches" },
          { title: "How a claim works", items: "WhatsApp us a photo and a short description of the issue\nWe respond within 2 working days\nA technician visits your home to inspect and, where possible, repair on the spot\nIf a repair isn't possible, we replace the affected part or piece" },
          { title: "Who provides service", items: "Furniversal's own service team in Bengaluru\nOriginal fabrics, leathers and mechanisms from our factory\nFree service visits within Bengaluru; travel charges may apply elsewhere" },
          { title: "What you receive", items: "A warranty card with your invoice on delivery\nYour configuration, fabric or leather and colour on record\nA care guide for your material\nA single WhatsApp number for support" }
        ]
      },
      care: {
        eyebrow: "Care & maintenance",
        title: "Keep it looking new",
        cards: [
          { title: "Fabric sofas", items: "Vacuum weekly with the upholstery brush\nBlot spills at once with a clean, dry cloth, never rub\nRotate and plump loose cushions every few weeks\nKeep out of direct sunlight to prevent fading\nProfessional cleaning once a year" },
          { title: "Genuine leather", items: "Dust with a soft, dry cloth\nWipe spills immediately; use only a damp cloth, no household cleaners\nCondition with a leather cream every 6 months\nKeep at least a metre from heaters and out of direct sun\nNatural marks and gentle creasing are part of real leather" },
          { title: "Recliners", items: "Keep the recline path clear of rugs and cables\nDon't sit on the footrest when it's extended\nUse the child lock when little ones are around\nUnplug power recliners before cleaning underneath" }
        ]
      },
      policies: {
        eyebrow: "Policies",
        title: "The fine print, in plain language",
        blocks: [
          { id: "terms",    title: "Terms & Conditions", body: "By placing an order with Furniversal you agree to these terms. Orders are confirmed on receipt of the advance payment stated on your invoice. Custom sofas are manufactured to the configuration, dimensions, material and colour you approve in writing (WhatsApp counts). Please check them carefully: they cannot be changed once production has started.\n\nPrices shown on the website are starting prices in Indian Rupees for the base configuration and are indicative until confirmed on an invoice. Delivery timelines are estimates and depend on the availability of the fabric or leather you choose.\n\nAll content on this website, including product photography and videos, belongs to Furniversal and may not be reused without permission." },
          { id: "privacy",  title: "Privacy Policy",     body: "We collect only what we need to help you: your name, WhatsApp number, and details about the sofa or room you tell us about. Website forms open a pre-filled WhatsApp chat; nothing is stored on this website.\n\nWe use your details to respond to your enquiry, prepare estimates, deliver and service your order and, if you agree, to share new collections. We never sell your data. You can ask us to delete your details at any time by messaging us on WhatsApp." },
          { id: "refund",   title: "Refund Policy",      body: "For standard-configuration pieces returned within 7 days under our return policy, the full amount paid is refunded to the original payment method within 7 to 10 working days of the piece being collected.\n\nCustom-sized or custom-configured sofas are built specifically for you. Advances on these orders are non-refundable once production has started, but the piece is fully covered by the 10-year warranty." },
          { id: "shipping", title: "Shipping Policy",    body: "Delivery and installation are free within Bengaluru. Our own team delivers, places and installs the sofa, and takes the packaging away. Custom orders are delivered in approximately 30 days from confirmation, subject to material availability; we'll keep you updated on WhatsApp.\n\nFor delivery outside Bengaluru, we quote transport charges up front and pack every piece for safe transit." },
          { id: "returns",  title: "Return Policy",      body: "A no-questions-asked 7-day return applies to standard-configuration pieces in their original condition. Message us on WhatsApp within 7 days of delivery and we'll arrange collection.\n\nSofas made to a custom size, configuration, material or colour can't be returned, because they were built for your room. If anything about them isn't right, the 10-year warranty and our service team have you covered." }
        ]
      },
      cta: {
        image: "assets/img/home/banner.jpg",
        eyebrow: "Still have a question?",
        title: "Ask us anything, no obligations",
        text: "A designer replies on WhatsApp within minutes.",
        cta1: { label: "Chat on WhatsApp", href: "whatsapp:Hi Furniversal, I have a question." },
        cta2: { label: "Visit the Showroom", href: "showroom.html" }
      }
    },

    /* ---------------- Brands page ---------------- */
    brands: {
      seo: {
        title: "Brands | Furniversal",
        description: "The houses behind Furniversal, our own in-house design label alongside a curated circle of partner furniture and interior brands: HomesToLife, Living Concepts and HomeLane."
      },
      hero: {
        eyebrow: "Our Portfolio",
        title: "The houses behind Furniversal",
        text: "Our own in-house label, and a small circle of furniture houses we trust beside it."
      },
      house: {
        tag: "The House Label",
        title: "Furniversal,",
        titleAccent: "The Curated Art of Living",
        text: "Our own design house, not a reseller. Every collection is conceived in-house for Indian homes and built to your brief, down to the dimension, fabric, leather and finish.",
        pills: "Original Global Designs\nBespoke Customisation\nArchitect-Led Builds",
        buttonLabel: "Explore the Collection",
        buttonHref: "shop.html",
        image: "assets/img/logo.png",
        frameLabel: "Designed, not just sold."
      },
      partnersHead: {
        eyebrow: "Alongside Furniversal",
        title: "The brands we bring into your home",
        text: "A few names we trust, each strong in a different part of the home."
      },
      partners: [
        {
          kicker: "Singapore Heritage · Imported Design",
          logo: "assets/img/brands/homestolife.png",
          name: "HomesToLife",
          sub: "Singapore's premium furniture house, in India",
          text: "Singapore-designed leather and fabric sofas, recliners, dining and bedroom pieces, finished to an export-grade standard and tailored to your room.",
          tags: "Leather & Fabric Sofas, Recliners, Dining & Bedroom"
        },
        {
          kicker: "Modular Living · India-Designed",
          logo: "assets/img/brands/livingconcepts.png",
          name: "Living Concepts",
          sub: "Formerly Urban Living",
          text: "India-made sofas for city homes, from compact mid-century seating to the Luxe range of modular loungers and deep chaise pieces.",
          tags: "Modular Sofas, Compact-Home Seating, Luxe Loungers"
        },
        {
          kicker: "Interior Design · Turnkey Homes",
          logo: "assets/img/brands/homelane.svg",
          name: "HomeLane",
          sub: "Bengaluru, since 2014",
          text: "One of India's largest home-interiors platforms: factory-built modular kitchens, wardrobes and furniture with 3D design, itemised pricing and a 45-day delivery promise.",
          tags: "Modular Kitchens, Wardrobes, Turnkey Interiors"
        }
      ],
      cta: {
        title: "Not sure which house is right for your space?",
        text: "Tell us the room and the brief. We'll point you to the right house.",
        buttonLabel: "Start a Conversation",
        buttonHref: "whatsapp:Hi Furniversal, I'd like help choosing the right brand for my space."
      },
      about: {
        eyebrow: "About Furniversal",
        title: "One brand for furniture & interiors",
        body: "A home feels its best when the furniture and the interiors are designed together. So we put made-to-order furniture and complete home interiors under one roof.\n\nFrom a single sofa to a full-home fit-out, one team handles concept, materials, manufacturing, installation and styling.",
        sign: "The Furniversal Team",
        stats: [
          { num: "500", suffix: "+", label: "Homes Designed" },
          { num: "20",  suffix: "+", label: "Furniture Collections" },
          { num: "4.9", suffix: "★", label: "Average Client Rating" },
          { num: "10",  suffix: "Yr", label: "Premium Warranty" }
        ]
      }
    },

    /* ---------------- Interiors page ---------------- */
    interiors: {
      seo: {
        title: "Interiors | Furniversal",
        description: "Interiors by Furniversal, full rooms planned, sourced and finished around one design language. Space planning, material palettes, bespoke furniture, styling and handover."
      },
      hero: {
        eyebrow: "Interiors by Furniversal",
        title: "Spaces, *conceived*, not decorated.",
        text: "Full rooms planned, sourced and finished around one design language.",
        image: "assets/img/home/hero-2.jpg"
      },
      philosophy: {
        eyebrow: "The Philosophy",
        title: "One idea, worked from three directions",
        text: "Global design, Indian craft and a premium finish, balanced so a home reads as considered, not imported and not generic.",
        cards: [
          { title: "Global Design",  text: "International design language, reset for Indian light and proportion." },
          { title: "Indian Craft",   text: "Joinery, upholstery and finishing done by hand in Indian workshops." },
          { title: "Curated Living", text: "Every room edited down to what earns its place." }
        ]
      },
      pillars: {
        eyebrow: "What's Included",
        title: "Four disciplines, one project",
        text: "Four decisions, made together.",
        cards: [
          { num: "I",   title: "Space Planning",      text: "Layouts from your floor plan: flow, sightlines and scale, before any piece is chosen." },
          { num: "II",  title: "Palette & Material",  text: "Wood, upholstery, stone and metal chosen to sit together, not compete." },
          { num: "III", title: "Bespoke Furniture",   text: "Pieces built to the room's exact dimensions, plus sourced pieces where they fit better." },
          { num: "IV",  title: "Styling & Handover",  text: "Soft furnishings, décor and styling done on-site." }
        ]
      },
      process: {
        eyebrow: "How It Works",
        title: "From first walkthrough to move-in",
        text: "From the first visit to a finished room.",
        steps: [
          { num: "01", title: "Walkthrough", text: "We visit the space, or review your drawings, and learn how you live in it." },
          { num: "02", title: "Concept",     text: "A moodboard and layout per room, agreed before anything is built." },
          { num: "03", title: "Materials",   text: "Fabric, leather, wood and finish chosen from samples, with an itemised quote." },
          { num: "04", title: "Build",       text: "Bespoke pieces made to spec, on a schedule shared upfront." },
          { num: "05", title: "Install",     text: "Delivery, placement and final styling on-site." }
        ]
      },
      portfolio: {
        eyebrow: "A Look at the Work",
        title: "Rooms we've shaped",
        text: "From a formal living room to a considered home office.",
        cards: [
          { image: "assets/img/home/feature-living.jpg",  kicker: "Living",  title: "The Formal Living Room" },
          { image: "assets/img/home/cta.jpg",             kicker: "Dining",  title: "The Gathering Table" },
          { image: "assets/img/home/feature-bedroom.jpg", kicker: "Bedroom", title: "The Quiet Bedroom" },
          { image: "assets/img/home/banner.jpg",          kicker: "Study",   title: "The Home Office" }
        ]
      },
      cta: {
        title: "Have a space in mind?",
        text: "Share a floor plan or a few photos and we'll start with a concept, no obligation.",
        buttonLabel: "Start Your Interior",
        buttonHref: "whatsapp:Hi Furniversal, I'd like to start an interior project for my space."
      }
    }
  };
})();

/* =========================================================
   2. SCHEMA — how the admin panel renders the editor
   ---------------------------------------------------------
   pages[] → sections[] → fields[]

   Field types
     text        one-line text
     textarea    paragraph of text
     rich        text where a line break becomes a new line and
                 *word* becomes italic (used for big headlines)
     lines       one entry per line (bullet lists, dropdown options)
     paragraphs  leave a blank line between paragraphs
     image       photo picker (upload or choose from the library)
     video       video picker
     link        page / whatsapp: / https:// link
     products    tick which products to feature
     select      pick one of a fixed set (icons)
     color       a colour swatch (picker + hex code)
     list        a repeatable block (cards, steps, FAQ entries…)
   ========================================================= */
(function () {
  "use strict";

  var ICONS = [
    { value: "shield", label: "Shield (warranty)" },
    { value: "layers", label: "Layers (execution)" },
    { value: "price",  label: "Price tag" },
    { value: "person", label: "Person (consultation)" },
    { value: "star",   label: "Star (quality)" },
    { value: "truck",  label: "Delivery" },
    { value: "check",  label: "Tick" },
    { value: "ruler",  label: "Ruler (custom size)" },
    { value: "seat",   label: "Seat (comfort)" },
    { value: "fabric", label: "Fabric swatch" },
    { value: "palette",label: "Colour palette" },
    { value: "clock",  label: "Clock (delivery time)" },
    { value: "sofa",   label: "Sofa" },
    { value: "hand",   label: "Hand (touch & feel)" },
    { value: "eye",    label: "Eye (see it)" },
    { value: "chat",   label: "Chat bubble" },
    { value: "map",    label: "Map pin" },
    { value: "phone",  label: "Phone" },
    { value: "mail",   label: "Email" },
    { value: "award",  label: "Award (experience)" },
    { value: "pen",    label: "Pen (designers)" },
    { value: "home",   label: "Home" },
    { value: "refresh",label: "Return / refresh" },
    { value: "tool",   label: "Tools (installation)" }
  ];

  // Shorthands so the schema below stays readable
  function t(k, l, hint)  { return { key: k, label: l, type: "text", hint: hint }; }
  function ta(k, l, hint) { return { key: k, label: l, type: "textarea", hint: hint }; }
  function img(k, l, hint){ return { key: k, label: l, type: "image", hint: hint }; }
  function lnk(k, l, hint){ return { key: k, label: l, type: "link", hint: hint }; }

  // The eyebrow / heading / intro trio that opens almost every section
  function head(base, opts) {
    opts = opts || {};
    var f = [
      t(base + ".eyebrow", "Small label above the heading"),
      t(base + ".title", "Heading")
    ];
    if (opts.noText !== true) f.push(ta(base + ".text", "Intro paragraph"));
    return f;
  }

  // A button: label + where it goes
  function button(base, label) {
    return [
      t(base + "Label", (label || "Button") + " text"),
      lnk(base + "Href", (label || "Button") + " link")
    ];
  }
  function cta(base, label) {
    return [
      t(base + ".label", (label || "Button") + " text"),
      lnk(base + ".href", (label || "Button") + " link")
    ];
  }

  window.FV_CONTENT_SCHEMA = [

    /* ================= GLOBAL ================= */
    {
      id: "global",
      label: "Global",
      icon: "🌐",
      hint: "Logo, menu, contact details, colour swatches, footer and the WhatsApp chat bubble. These appear on every page.",
      sections: [
        {
          label: "Logo",
          fields: [
            img("global.logo", "Logo (dark pages / header)"),
            img("global.logoLight", "Logo (footer, light version)")
          ]
        },
        {
          label: "WhatsApp & contact details",
          hint: "Change the number here and every WhatsApp button on the site follows.",
          fields: [
            t("global.whatsapp.number", "WhatsApp number", "Country code, no + or spaces. e.g. 919148236891"),
            t("global.whatsapp.display", "How the number is shown", "e.g. +91 91482 36891"),
            ta("global.whatsapp.greeting", "Default chat message"),
            t("global.contact.email", "Email address"),
            t("global.contact.address", "Showroom address", "Shown in the footer and on the Showroom page"),
            t("global.contact.mapUrl", "Google Maps link", "The 'Get directions' link"),
            t("global.contact.mapEmbed", "Google Maps embed link", "From Google Maps → Share → Embed a map → copy the src=\"…\" address"),
            t("global.contact.hoursLabel", "Opening-hours label"),
            t("global.contact.hoursValue", "Opening hours")
          ]
        },
        {
          label: "Social links",
          hint: "Leave a link blank to hide that icon.",
          fields: [
            t("global.contact.instagramHandle", "Instagram handle"),
            t("global.contact.instagramUrl", "Instagram link"),
            t("global.contact.youtubeUrl", "YouTube link"),
            t("global.contact.pinterestUrl", "Pinterest link"),
            t("global.contact.xUrl", "X (Twitter) link"),
            t("global.contact.facebookUrl", "Facebook link")
          ]
        },
        {
          label: "Colour swatches",
          hint: "The fabric and leather colours offered on every sofa. Shown on the product page and counted on the shop cards.",
          fields: [
            { key: "global.swatches.fabric", type: "list", label: "Premium fabric colours", itemLabel: "Colour", titleField: "name",
              fields: [t("name", "Colour name"), { key: "hex", label: "Swatch colour", type: "color", hint: "Pick the colour or type its code, e.g. #6B6B4A" }] },
            { key: "global.swatches.leather", type: "list", label: "Genuine leather colours", itemLabel: "Colour", titleField: "name",
              fields: [t("name", "Colour name"), { key: "hex", label: "Swatch colour", type: "color", hint: "Pick the colour or type its code, e.g. #8B4A2B" }] }
          ]
        },
        {
          label: "Top menu",
          fields: [
            {
              key: "global.nav", type: "list", label: "Menu links", itemLabel: "Link", titleField: "label",
              fields: [t("label", "Label"), lnk("href", "Link")]
            },
            t("global.headerCta.label", "Header button text"),
            lnk("global.headerCta.href", "Header button link")
          ]
        },
        {
          label: "WhatsApp chat bubble",
          fields: [
            { key: "global.widget.logo", label: "Logo in the chat header", type: "image", hint: "A white icon or logo on a transparent background works best." },
            t("global.widget.name", "Chat title"),
            t("global.widget.status", "Status line"),
            t("global.widget.senderName", "Sender name"),
            ta("global.widget.message", "Welcome message"),
            t("global.widget.ctaLabel", "Chat button text")
          ]
        },
        {
          label: "Footer",
          fields: [
            ta("global.footer.blurb", "About blurb"),
            t("global.footer.exploreTitle", "Column 1 heading"),
            {
              key: "global.footer.exploreLinks", type: "list", label: "Column 1 links", itemLabel: "Link", titleField: "label",
              fields: [t("label", "Label"), lnk("href", "Link")]
            },
            t("global.footer.categoriesTitle", "Column 2 heading"),
            {
              key: "global.footer.categoryLinks", type: "list", label: "Column 2 links", itemLabel: "Link", titleField: "label",
              fields: [t("label", "Label"), lnk("href", "Link")]
            },
            t("global.footer.contactTitle", "Column 3 heading"),
            { key: "global.footer.notes", label: "Column 3 notes", type: "lines", hint: "One per line" },
            t("global.footer.ctaLabel", "Footer button text"),
            lnk("global.footer.ctaHref", "Footer button link"),
            {
              key: "global.footer.policyLinks", type: "list", label: "Policy links (bottom row)", itemLabel: "Link", titleField: "label",
              fields: [t("label", "Label"), lnk("href", "Link")]
            },
            t("global.footer.copyright", "Copyright line")
          ]
        }
      ]
    },

    /* ================= HOME ================= */
    {
      id: "home",
      label: "Home page",
      icon: "🏠",
      page: "index.html",
      sections: [
        {
          label: "Browser tab & Google listing",
          hint: "The title shown on the browser tab and in search results, and the summary under it.",
          fields: [
            t("home.seo.title", "Page title"),
            ta("home.seo.description", "Search description", "Around 150-160 characters works best")
          ]
        },
        {
          label: "Hero (top of the page)",
          fields: [
            t("home.hero.eyebrow", "Small label above the heading"),
            { key: "home.hero.title", label: "Big heading", type: "rich", hint: "New line = line break. Put *stars* around a word to italicise it." },
            ta("home.hero.text", "Intro paragraph"),
            { key: "home.hero.pills", label: "Pills under the intro", type: "lines", hint: "One per line, e.g. Fabric / Genuine leather" },
            t("home.hero.studio", "Studio line", "e.g. 5,000 sq.ft. Custom Sofa Studio, Banaswadi"),
            lnk("home.hero.studioHref", "Studio line link"),
            t("home.hero.trust", "Credentials line", "e.g. 50 years of manufacturing experience · Designed by globally renowned designers"),
            { key: "home.hero.video", label: "Background video", type: "video" },
            img("home.hero.poster", "Fallback image", "Shown while the video loads"),
            t("home.hero.scrollLabel", "Scroll hint text")
          ].concat(cta("home.hero.cta1", "Primary button"), cta("home.hero.cta2", "Secondary button"))
        },
        {
          label: "Proof strip (under the hero)",
          hint: "The five big numbers: price from, delivery, experience, warranty, studio.",
          fields: [{
            key: "home.proof", type: "list", label: "Numbers", itemLabel: "Item", titleField: "label",
            fields: [t("num", "Big number / figure"), t("label", "Label under it")]
          }]
        },
        {
          label: "Shop by category strip",
          fields: [
            t("home.categories.title", "Heading"),
            t("home.categories.linkLabel", "Side link text"),
            lnk("home.categories.linkHref", "Side link"),
            t("home.categories.moreLabel", "\"Also made to order\" label"),
            { key: "home.categories.more", label: "Also made to order (chips)", type: "lines", hint: "One per line. Each chip opens a WhatsApp enquiry for that item." },
            {
              key: "home.categories.cards", type: "list", label: "Tiles", itemLabel: "Tile", titleField: "title",
              fields: [img("image", "Photo"), t("title", "Tile heading"), t("kicker", "Small label under it"), lnk("href", "Link")]
            }
          ]
        },
        {
          label: "Bestsellers",
          fields: head("home.featured").concat([
            { key: "home.featured.slugs", label: "Products to feature", type: "products", hint: "Tick the pieces shown on the home page, in order (8 works best)." }
          ]).concat(button("home.featured.button", "Button"))
        },
        {
          label: "Furniture in motion (video reels)",
          hint: "The clips come from each product's videos in the Products tab. Clips carry no product name; tapping one opens the product.",
          fields: head("home.motion").concat([
            t("home.motion.linkLabel", "Hover label on each clip"),
            t("home.motion.max", "Maximum clips in the carousel", "e.g. 20"),
            t("home.motion.speed", "Auto-scroll speed (pixels per second)", "The clips glide on their own and pause under the pointer. 30 is gentle; 0 turns the glide off."),
            t("home.motion.autoMs", "Resume the glide after (milliseconds)", "Pause after the visitor scrolls, drags or taps the reel. 6000 = 6 seconds.")
          ])
        },
        {
          label: "Why Furniversal? (designed around you)",
          fields: [
            t("home.custom.eyebrow", "Small label"),
            t("home.custom.title", "Heading"),
            t("home.custom.quote", "Big quote"),
            ta("home.custom.quoteSub", "Line under the quote"),
            t("home.custom.flow", "Journey line", "e.g. Visit the studio → sit on it → customise it → we build it"),
            {
              key: "home.custom.tiles", type: "list", label: "Six tiles", itemLabel: "Tile", titleField: "title",
              fields: [{ key: "icon", label: "Icon", type: "select", options: ICONS }, t("title", "Tile heading"), ta("text", "Tile text")]
            }
          ]
        },
        {
          label: "Design your sofa (estimate form)",
          hint: "Also shown on every product page. Submissions open a pre-filled WhatsApp chat.",
          fields: head("home.estimate").concat([
            { key: "home.estimate.bullets", label: "Tick list", type: "lines", hint: "One per line" },
            t("home.estimate.formTitle", "Form heading"),
            t("home.estimate.formNote", "Form note"),
            t("home.estimate.typeLabel", "Question 1 label"),
            { key: "home.estimate.types", label: "Question 1 options", type: "lines", hint: "One per line" },
            t("home.estimate.materialLabel", "Question 2 label"),
            { key: "home.estimate.materials", label: "Question 2 options", type: "lines", hint: "One per line" },
            t("home.estimate.colourLabel", "Colour field label"),
            t("home.estimate.colourPlaceholder", "Colour field placeholder"),
            t("home.estimate.roomLabel", "Room size field label"),
            t("home.estimate.roomPlaceholder", "Room size placeholder"),
            t("home.estimate.photoNote", "Room photo tick-box text", "The visitor ticks this to say a photo is coming"),
            t("home.estimate.photoLine", "Room photo line in the WhatsApp message", "Sent as 'Room photo: …' when the box is ticked"),
            t("home.estimate.budgetLabel", "Budget label"),
            { key: "home.estimate.budgets", label: "Budget options", type: "lines", hint: "One per line" },
            t("home.estimate.nameLabel", "Name field label"),
            t("home.estimate.phoneLabel", "WhatsApp field label"),
            t("home.estimate.submitLabel", "Submit button text"),
            t("home.estimate.visitLabel", "Second button text"),
            t("home.estimate.disclaimer", "Small print")
          ])
        },
        {
          label: "Why custom? (comparison)",
          fields: [
            t("home.compare.eyebrow", "Small label"),
            t("home.compare.title", "Heading"),
            t("home.compare.standardTitle", "Left column heading"),
            { key: "home.compare.standardItems", label: "Left column points", type: "lines", hint: "One per line" },
            t("home.compare.customTitle", "Right column heading"),
            { key: "home.compare.customItems", label: "Right column points", type: "lines", hint: "One per line" }
          ]
        },
        {
          label: "Showroom band",
          fields: head("home.showroom").concat([
            img("home.showroom.image", "Photo"),
            t("home.showroom.badgeNum", "Badge number"),
            t("home.showroom.badgeText", "Badge text"),
            { key: "home.showroom.list", label: "What you'll experience", type: "lines", hint: "One per line" }
          ]).concat(cta("home.showroom.cta1", "Primary button"), cta("home.showroom.cta2", "Secondary button"))
        },
        {
          label: "Google reviews",
          fields: head("home.reviews").concat([
            t("home.reviews.more", "\"Read more\" button (long reviews)"),
            t("home.reviews.less", "\"Show less\" button"), {
            key: "home.reviews.items", type: "list", label: "Reviews", itemLabel: "Review", titleField: "name",
            fields: [t("name", "Reviewer name"), t("time", "When", "e.g. 2 weeks ago"), ta("text", "Review")]
          }])
        },
        {
          label: "\"From a single sofa\" interiors section",
          fields: head("home.split").concat([
            { key: "home.split.bullets", label: "Tick list", type: "lines", hint: "One per line" },
            img("home.split.image", "Photo"),
            t("home.split.badgeNum", "Badge number"),
            t("home.split.badgeText", "Badge text")
          ]).concat(button("home.split.button", "Button"))
        },
        {
          label: "FAQ",
          fields: head("home.faq", { noText: true }).concat([{
            key: "home.faq.items", type: "list", label: "Questions", itemLabel: "Question", titleField: "q",
            fields: [t("q", "Question"), ta("a", "Answer")]
          }])
        },
        {
          label: "Contact section",
          fields: head("home.contact").concat([
            t("home.contact.formTitle", "Form heading"),
            t("home.contact.formNote", "Form note"),
            { key: "home.contact.interests", label: "\"I'm interested in\" options", type: "lines", hint: "One per line" },
            t("home.contact.submitLabel", "Submit button text"),
            t("home.contact.sendLabel", "Send enquiry button text"),
            t("home.contact.sending", "Sending… status"),
            ta("home.contact.sentMsg", "Thank-you message after sending"),
            ta("home.contact.sendError", "Error message if sending fails"),
            ta("home.contact.sendFallback", "Message when the email app opens instead (hosts without PHP)"),
            t("home.contact.needName", "Validation: name missing"),
            t("home.contact.disclaimer", "Small print under the form")
          ])
        },
        {
          label: "Closing banner",
          fields: [
            img("home.cta.image", "Background photo"),
            t("home.cta.eyebrow", "Small label"),
            t("home.cta.title", "Heading"),
            ta("home.cta.text", "Text")
          ].concat(cta("home.cta.cta1", "Primary button"), cta("home.cta.cta2", "Secondary button"))
        }
      ]
    },

    /* ================= SHOP ================= */
    {
      id: "shop",
      label: "Shop page",
      icon: "🛋",
      page: "shop.html",
      hint: "The product grid and its filters come from the Products tab.",
      sections: [
        {
          label: "Browser tab & Google listing",
          hint: "The title shown on the browser tab and in search results, and the summary under it.",
          fields: [
            t("shop.seo.title", "Page title"),
            ta("shop.seo.description", "Search description", "Around 150-160 characters works best")
          ]
        },
        { label: "Reassurance strip", fields: [{ key: "shop.help", label: "Reassurance strip", type: "lines", hint: "One per line, shown above the grid" }] },
        {
          label: "Cards & filters",
          fields: [
            t("shop.card.fromLabel", "Price prefix on cards", "e.g. From"),
            t("shop.card.moreColours", "Word after the colour count", "e.g. colours"),
            t("shop.filters.allMaterials", "Material filter: all"),
            t("shop.filters.fabric", "Material filter: fabric"),
            t("shop.filters.leather", "Material filter: leather"),
            ta("shop.filters.empty", "Message when no piece matches")
          ]
        },
        { label: "Closing banner", fields: head("shop.cta").concat(button("shop.cta.button", "Button")) }
      ]
    },

    /* ================= PRODUCT PAGE ================= */
    {
      id: "product",
      label: "Product page",
      icon: "🏷",
      page: "product.html",
      hint: "The wording shared by every product page. Each product's own words, price, size and colours live in the Products tab.",
      sections: [
        {
          label: "Name & price",
          fields: [
            t("product.detail.namePrefix", "Word before the product name", "e.g. Furniversal → 'Furniversal Dundee'"),
            t("product.detail.titleSuffix", "Browser-tab suffix"),
            t("product.detail.fromLabel", "Label above the price"),
            t("product.detail.priceTag", "Shown when a product has no price"),
            t("product.detail.priceSub", "Sub-line when a product has no price"),
            { key: "product.detail.perks", label: "Perks under the price", type: "lines", hint: "One per line, e.g. No Cost EMI available" }
          ]
        },
        {
          label: "Specification labels",
          fields: [
            t("product.detail.sizeLabel", "Size label"),
            t("product.detail.sizeCustom", "Size text when no dimensions are set"),
            ta("product.detail.sizeNote", "Note under the size diagram"),
            t("product.detail.configLabel", "Configuration label"),
            t("product.detail.configCustom", "Custom configuration chip"),
            t("product.detail.dataSheet", "Data-sheet link text", "Opens a WhatsApp request for the piece's customisation data sheet"),
            t("product.detail.materialLabel", "Material label"),
            t("product.detail.matLeatherFull", "Material chip 1"),
            t("product.detail.matLeatherHalf", "Material chip 2"),
            t("product.detail.matFabric", "Material chip 3"),
            t("product.detail.colourLabel", "Colour label"),
            t("product.detail.colourOwn", "Heading over the product's own colour"),
            t("product.detail.colourFabric", "Heading over fabric swatches"),
            t("product.detail.colourLeather", "Heading over leather swatches"),
            t("product.detail.comfortLabel", "Comfort label"),
            t("product.detail.deliveryLabel", "Delivery label"),
            t("product.detail.deliveryValue", "Delivery value"),
            t("product.detail.deliveryNote", "Delivery note"),
            t("product.detail.warrantyLabel", "Warranty label"),
            t("product.detail.warrantyValue", "Warranty value"),
            t("product.detail.warrantyNote", "Warranty link text"),
            t("product.detail.featuresLabel", "Features heading")
          ]
        },
        {
          label: "Trust line, buttons & help box",
          fields: [
            t("product.detail.trust1", "Trust point 1"),
            t("product.detail.trust2", "Trust point 2"),
            t("product.detail.trust3", "Trust point 3"),
            t("product.detail.trust4", "Trust point 4 (links to Customer services)"),
            t("product.detail.enquireLabel", "WhatsApp button text"),
            t("product.detail.consultLabel", "Showroom button text"),
            t("product.detail.estimateLabel", "Estimate button text"),
            t("product.detail.helpTitle", "Help box heading"),
            t("product.detail.helpText", "Help box text"),
            t("product.detail.helpCta", "Help box link"),
            t("product.detail.stickyWa", "Mobile bar: WhatsApp"),
            t("product.detail.stickyEstimate", "Mobile bar: estimate"),
            t("product.detail.videoEyebrow", "Video section label"),
            t("product.detail.videoTitle", "Video section heading")
          ]
        },
        {
          label: "Maintenance guide, warranty & shipping (fold-outs)",
          hint: "Three fold-out panels under the key features. Their content comes from the Customer services page (Care & maintenance, 10-year warranty, Policies); the fabric / leather / recliner tips shown are matched to each piece's material.",
          fields: [
            t("product.detail.guideCare", "Maintenance guide heading"),
            t("product.detail.guideCareLink", "Maintenance guide link text"),
            t("product.detail.guideWarranty", "Warranty heading"),
            t("product.detail.guideWarrantyLink", "Warranty link text"),
            t("product.detail.guideShipping", "Shipping & returns heading"),
            t("product.detail.guideShippingLink", "Shipping & returns link text")
          ]
        },
        {
          label: "Customise this sofa band",
          fields: head("product.customise").concat([{
            key: "product.customise.steps", type: "list", label: "Steps", itemLabel: "Step", titleField: "title",
            fields: [t("num", "Number"), t("title", "Step heading"), ta("text", "Step text")]
          }], [t("product.customise.ctaLabel", "Button text"), lnk("product.customise.ctaHref", "Button link")])
        },
        {
          label: "Product rows",
          fields: [
            t("product.family.eyebrow", "Same family: small label"),
            t("product.family.title", "Same family: heading start", "The family name is added after it"),
            t("product.family.suffix", "Same family: heading end", "e.g. 'More from the' + Dundee + 'family'"),
            t("product.family.shapesEyebrow", "Shapes & sizes: small label", "Shown when a piece has no family mates yet: its other configurations become tiles"),
            t("product.family.shapesTitle", "Shapes & sizes: heading end", "The product name is added before it"),
            t("product.family.shapesCta", "Shapes & sizes: tile link text"),
            t("product.related.eyebrow", "Recommended: small label"),
            t("product.related.title", "Recommended: heading"),
            t("product.recent.eyebrow", "Recently viewed: small label"),
            t("product.recent.title", "Recently viewed: heading")
          ]
        },
        {
          label: "Closing banner",
          fields: [
            img("product.cta.image", "Background photo"),
            t("product.cta.eyebrow", "Small label"),
            t("product.cta.title", "Heading"),
            ta("product.cta.text", "Text")
          ].concat(cta("product.cta.cta1", "Primary button"), cta("product.cta.cta2", "Secondary button"))
        }
      ]
    },

    /* ================= SHOWROOM ================= */
    {
      id: "showroom",
      label: "Showroom page",
      icon: "🏬",
      page: "showroom.html",
      sections: [
        {
          label: "Browser tab & Google listing",
          fields: [
            t("showroom.seo.title", "Page title"),
            ta("showroom.seo.description", "Search description", "Around 150-160 characters works best")
          ]
        },
        {
          label: "Page header",
          fields: [
            t("showroom.hero.eyebrow", "Small label"),
            { key: "showroom.hero.title", label: "Big heading", type: "rich", hint: "Put *stars* around a word to italicise it." },
            ta("showroom.hero.text", "Intro paragraph"),
            img("showroom.hero.image", "Photo"),
            { key: "showroom.hero.facts", type: "list", label: "Facts", itemLabel: "Fact", titleField: "label", fields: [t("num", "Number"), t("label", "Label")] }
          ].concat(cta("showroom.hero.cta1", "Primary button"), cta("showroom.hero.cta2", "Secondary button"))
        },
        {
          label: "What you'll experience",
          fields: head("showroom.experience").concat([{
            key: "showroom.experience.cards", type: "list", label: "Cards", itemLabel: "Card", titleField: "title",
            fields: [{ key: "icon", label: "Icon", type: "select", options: ICONS }, t("title", "Card heading"), ta("text", "Card text")]
          }])
        },
        {
          label: "Book a visit",
          fields: head("showroom.visit").concat([
            t("showroom.visit.formTitle", "Form heading"),
            t("showroom.visit.formNote", "Form note"),
            { key: "showroom.visit.interests", label: "\"Looking for\" options", type: "lines", hint: "One per line" },
            t("showroom.visit.submitLabel", "Submit button text"),
            t("showroom.visit.disclaimer", "Small print")
          ])
        },
        { label: "Reviews heading", hint: "The reviews themselves are the Google reviews from the Home page.", fields: head("showroom.reviews", { noText: true }) },
        {
          label: "Happy homes (photo stories)",
          hint: "Photo + one line from a real customer. Replace the sample lines with real ones.",
          fields: head("showroom.stories", { noText: true }).concat([{
            key: "showroom.stories.cards", type: "list", label: "Stories", itemLabel: "Story", titleField: "quote",
            fields: [img("image", "Photo"), ta("quote", "What they said"), t("name", "Who / where")]
          }])
        },
        {
          label: "Virtual tour",
          fields: head("showroom.tour").concat([
            { key: "showroom.tour.video", label: "Tour video", type: "video" },
            img("showroom.tour.poster", "Poster image")
          ])
        },
        {
          label: "Closing banner",
          fields: [
            img("showroom.cta.image", "Background photo"),
            t("showroom.cta.eyebrow", "Small label"),
            t("showroom.cta.title", "Heading"),
            ta("showroom.cta.text", "Text")
          ].concat(cta("showroom.cta.cta1", "Primary button"), cta("showroom.cta.cta2", "Secondary button"))
        }
      ]
    },

    /* ================= CUSTOMER SERVICES ================= */
    {
      id: "support",
      label: "Customer services",
      icon: "🛟",
      page: "support.html",
      sections: [
        {
          label: "Browser tab & Google listing",
          fields: [
            t("support.seo.title", "Page title"),
            ta("support.seo.description", "Search description", "Around 150-160 characters works best")
          ]
        },
        { label: "Page header", fields: head("support.hero") },
        {
          label: "Contact cards",
          fields: [{
            key: "support.cards", type: "list", label: "Cards", itemLabel: "Card", titleField: "title",
            fields: [{ key: "icon", label: "Icon", type: "select", options: ICONS }, t("title", "Heading"), ta("text", "Text"), t("btnLabel", "Button text"), lnk("btnHref", "Button link")]
          }]
        },
        {
          label: "10-year warranty",
          fields: head("support.warranty").concat([{
            key: "support.warranty.cards", type: "list", label: "Cards", itemLabel: "Card", titleField: "title",
            fields: [t("title", "Heading"), { key: "items", label: "Points", type: "lines", hint: "One per line" }]
          }])
        },
        {
          label: "Care & maintenance",
          fields: head("support.care", { noText: true }).concat([{
            key: "support.care.cards", type: "list", label: "Cards", itemLabel: "Card", titleField: "title",
            fields: [t("title", "Heading"), { key: "items", label: "Tips", type: "lines", hint: "One per line" }]
          }])
        },
        {
          label: "Policies",
          fields: head("support.policies", { noText: true }).concat([{
            key: "support.policies.blocks", type: "list", label: "Policies", itemLabel: "Policy", titleField: "title",
            fields: [t("id", "Anchor id", "lowercase, no spaces, e.g. terms"), t("title", "Heading"), { key: "body", label: "Text", type: "paragraphs", hint: "Leave a blank line between paragraphs" }]
          }])
        },
        {
          label: "Closing banner",
          fields: [
            img("support.cta.image", "Background photo"),
            t("support.cta.eyebrow", "Small label"),
            t("support.cta.title", "Heading"),
            ta("support.cta.text", "Text")
          ].concat(cta("support.cta.cta1", "Primary button"), cta("support.cta.cta2", "Secondary button"))
        }
      ]
    },

    /* ================= BRANDS ================= */
    {
      id: "brands",
      label: "Brands page",
      icon: "✦",
      page: "brands.html",
      sections: [
        {
          label: "Browser tab & Google listing",
          hint: "The title shown on the browser tab and in search results, and the summary under it.",
          fields: [
            t("brands.seo.title", "Page title"),
            ta("brands.seo.description", "Search description", "Around 150-160 characters works best")
          ]
        },
        {
          label: "The house label (Furniversal)",
          fields: [
            t("brands.house.tag", "Small label"),
            t("brands.house.title", "Heading"),
            t("brands.house.titleAccent", "Heading, highlighted part"),
            ta("brands.house.text", "Text"),
            { key: "brands.house.pills", label: "Pills", type: "lines", hint: "One per line" },
            img("brands.house.image", "Visual"),
            t("brands.house.frameLabel", "Caption under the visual")
          ].concat(button("brands.house.button", "Button"))
        },
        {
          label: "Partner brands",
          fields: head("brands.partnersHead").concat([{
            key: "brands.partners", type: "list", label: "Brands", itemLabel: "Brand", titleField: "name",
            fields: [
              t("kicker", "Small label"),
              img("logo", "Logo"),
              t("name", "Brand name", "Used as the logo's alt text"),
              t("sub", "One-line description"),
              ta("text", "Description"),
              t("tags", "Tags", "Separate with commas")
            ]
          }])
        },
        { label: "Closing banner", fields: [t("brands.cta.title", "Heading"), ta("brands.cta.text", "Text")].concat(button("brands.cta.button", "Button")) },
        {
          label: "About & stats",
          fields: [
            t("brands.about.eyebrow", "Small label"),
            t("brands.about.title", "Heading"),
            { key: "brands.about.body", label: "About text", type: "paragraphs", hint: "Leave a blank line between paragraphs" },
            t("brands.about.sign", "Sign-off"),
            {
              key: "brands.about.stats", type: "list", label: "Stats", itemLabel: "Stat", titleField: "label",
              fields: [t("num", "Number"), t("suffix", "Suffix", "e.g. + or ★ or Yr"), t("label", "Label")]
            }
          ]
        }
      ]
    },

    /* ================= INTERIORS ================= */
    {
      id: "interiors",
      label: "Interiors page",
      icon: "🪟",
      page: "interiors.html",
      sections: [
        {
          label: "Browser tab & Google listing",
          hint: "The title shown on the browser tab and in search results, and the summary under it.",
          fields: [
            t("interiors.seo.title", "Page title"),
            ta("interiors.seo.description", "Search description", "Around 150-160 characters works best")
          ]
        },
        {
          label: "Page header",
          fields: [
            t("interiors.hero.eyebrow", "Small label"),
            { key: "interiors.hero.title", label: "Big heading", type: "rich", hint: "Put *stars* around a word to italicise it." },
            ta("interiors.hero.text", "Intro paragraph"),
            img("interiors.hero.image", "Photo")
          ]
        },
        {
          label: "Philosophy",
          fields: head("interiors.philosophy").concat([{
            key: "interiors.philosophy.cards", type: "list", label: "Cards", itemLabel: "Card", titleField: "title",
            fields: [t("title", "Card heading"), ta("text", "Card text")]
          }])
        },
        {
          label: "What's included",
          fields: head("interiors.pillars").concat([{
            key: "interiors.pillars.cards", type: "list", label: "Cards", itemLabel: "Card", titleField: "title",
            fields: [t("num", "Number"), t("title", "Card heading"), ta("text", "Card text")]
          }])
        },
        {
          label: "How it works",
          fields: head("interiors.process").concat([{
            key: "interiors.process.steps", type: "list", label: "Steps", itemLabel: "Step", titleField: "title",
            fields: [t("num", "Number"), t("title", "Step heading"), ta("text", "Step text")]
          }])
        },
        {
          label: "Portfolio tiles",
          fields: head("interiors.portfolio").concat([{
            key: "interiors.portfolio.cards", type: "list", label: "Tiles", itemLabel: "Tile", titleField: "title",
            fields: [img("image", "Photo"), t("kicker", "Small label"), t("title", "Tile heading")]
          }])
        },
        { label: "Closing banner", fields: [t("interiors.cta.title", "Heading"), ta("interiors.cta.text", "Text")].concat(button("interiors.cta.button", "Button")) }
      ]
    }
  ];
})();
